import { ReactNode } from "react"
import { Tooltip } from "react-tooltip"
import "react-tooltip/dist/react-tooltip.css"

type Place = "top" | "right" | "bottom" | "left"

interface RichTooltipProps {
  content: ReactNode
  children: ReactNode
  place?: Place
}

export default function RichTooltip({
  content,
  children,
  place = "top",
}: RichTooltipProps) {
  const id = Math.random().toString(36).substring(7)

  return (
    <>
      <div data-tooltip-id={id}>{children}</div>
      <Tooltip
        border="2px solid #222250"
        opacity="1"
        id={id}
        place={place}
        className="!bg-system-blue-800 !border !border-[2px] !border-system-blue-700 !p-system-md !rounded-system-sm !text-basic-white z-[999999] !max-w-xs !break-words"
        classNameArrow="!bg-system-blue-800"
        delayShow={200}
        delayHide={500}
        positionStrategy="fixed"
      >
        <div className="whitespace-normal break-words">{content}</div>
      </Tooltip>
    </>
  )
}
